import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, delay, ease: EASE }}
            className={className}
        >
            {children}
        </Tag>
    );
};

export const Eyebrow = ({ index, children, dark = false }) => (
    <Reveal className="flex items-center gap-4 mb-6">
        {index && (
            <span className={`font-display text-xs font-medium tracking-[0.2em] ${dark ? "text-weyb-yellow" : "text-weyb-yellow"}`}>
                {index}
            </span>
        )}
        <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-weyb-ink/15"}`} aria-hidden="true" />
        <span className={`text-xs uppercase tracking-[0.22em] font-semibold ${dark ? "text-white/50" : "text-gray-500"}`}>
            {children}
        </span>
    </Reveal>
);
